import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { NotificationModal, AppType, UserGroupList } from '../../../Shared/Model/notification/notificationModal';
import { ErrorModel } from '../../../Shared/Model/error/error-model';
import { AdminService } from '../../../Shared/Services/Admin/admin.service';
import { ConfigLoaderService } from '../../../Shared/Services/Config/config-loader.service';
import { ErrorServiceService } from '../../../Shared/Services/Error/error-service.service';
import { NgForm } from '@angular/forms';
declare var $: any;
import { DatePipe } from '@angular/common'
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {


  notificationModal: NotificationModal = new NotificationModal();
  appTypeList!: AppType[];
  userGroupList!: UserGroupList[];
  // date = new FormControl(new Date());
  // serializedDate = new FormControl((new Date()).toISOString());
  errModal!: ErrorModel;
  @ViewChild('notificationform') notificationform!: NgForm;

  showalertMsg: boolean = false;
  alertMsg!: string;
  successMessage: string = "Details Submitted Successfully.";
  ErrorMessage: string = "Error in Submitting.";
  alertmsgClass!: string;


  appType: string = '';
  date: string = '';
  enddate: string = '';
  userGroup: string = '';
  message: string = '';

  usrGrp: any;

  dbUserGroup!:string;
  isDisabled:boolean=false;
  showError:boolean=false;
  uArr:any;
 

  group = new FormGroup({
    // filetype: new FormControl(null, Validators.required),
    // clientName: new FormControl(null,[
    //   Validators.required,

    // ]),

    // remarks: new FormControl(),
    // fileupload: new FormControl(null, [Validators.required]),

  });


  constructor(
    public modalRef: MDBModalRef,
    public _adminService: AdminService,
    private _errorService: ErrorServiceService,
    public _datePipe: DatePipe
  ) {
    this.errModal = new ErrorModel();
  }

  ngOnInit(): void {
    this.errModal.ComponentName = "NoticiationComponent";

    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.notificationModal.UserId = ConfigLoaderService.settings.DevValues.userName;
    }
    else {
      this.notificationModal.UserId = ConfigLoaderService.settings.AppSettings.userId;
    }
    this.isDisabled=false;
    this.getAppType();
    this.getUserGroup();


  }

  
  getAppType() {
    this.errModal.MethodName = "GETaPPtYPE";
    this.errModal.ErrorMessage = "Error getting getAppType";
    this._adminService
      .getAppTypeList(
        this.notificationModal.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.appTypeList = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        }
      );

  }
  getUserGroup() {

    this.errModal.MethodName = "getUserGroup";
    this.errModal.ErrorMessage = "Error getting getuserGroup";
    this._adminService
      .getUserGroupList(
        this.notificationModal.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.userGroupList = data;            
            this.getNotificationDetails();

          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        }
      );


  }

  getNotificationDetails() {
    this._adminService.selectNotification(ConfigLoaderService.settings.AppSettings.userId)
      .subscribe((data: any) => {

        console.log(data)
      
        if (data[0].appType != undefined) {
         
          this.notificationModal.appType = data[0].appType;

          let newDate = new Date(data[0].date);
          let latest_date = this._datePipe.transform(newDate, 'yyyy-MM-dd');
          this.notificationModal.date = latest_date?.toString();

          let newendDate = new Date(data[0].endDate);
          let latest_enddate = this._datePipe.transform(newendDate, 'yyyy-MM-dd');
          this.notificationModal.endDate = latest_enddate?.toString();

          this.notificationModal.message = data[0].message;
          this.dbUserGroup=data[0].userGroup;

       
          this.usrGrp = this.userGroupList.find(i => i.ID == data[0].userGroup);
          
         
          this.uArr=data[0].userGroup.split(',');
          
          this.notificationModal.userGroup = this.usrGrp;

          for (var i = 0; i < data[0].userGroup.split(',').length; i++) {
            var x = document.getElementById("UGroup")?.children[this.uArr[i]];
            x?.setAttribute("selected", "selected");
            x?.setAttribute("style", "background-color:#7500c0;color:white")

          }

         this.isDisabled=true;
          

        }

      });


  }


  onSubmit() {
    this.errModal.MethodName = "Submit";
    this.errModal.ErrorMessage = "Error on Submitting ";
   
    var selecteduserGroup=this.notificationModal.userGroup;

    console.log(selecteduserGroup)
    console.log(this.dbUserGroup)
   
   

    if(this.notificationModal.userGroup==undefined&&this.usrGrp==undefined){
      this.showError=true;
    }

    if(this.notificationModal.userGroup!=undefined){
      if(this.usrGrp != null && this.usrGrp != undefined)
      {
        console.log('hereh')
        if(Object.values(selecteduserGroup)[0]!=this.dbUserGroup)
        {
          this.notificationModal.userGroup=Object.values(selecteduserGroup)[0]+","+ this.dbUserGroup;
        }
        else{
          this.notificationModal.userGroup=this.dbUserGroup;
        }
      }
      else
      {
        console.log('hereh11')
        this.notificationModal.userGroup=Object.values(selecteduserGroup).join(",");
      }

    }
    else
    {
      console.log('hereh1111')
      this.notificationModal.userGroup=  this.dbUserGroup;
    }

    console.log(this.notificationModal.userGroup)
  
    // if (this.usrGrp != null && this.usrGrp != undefined) {
    //   this.notificationModal.userGroup =  this.dbUserGroup;
    // }
    // else {
    //   var userGroup = Object.values(this.notificationModal.userGroup).join(",");
    //   this.notificationModal.userGroup = userGroup;
    // }
    if (this.notificationModal.IsCompleted.toString().toUpperCase() == "TRUE") {
      this.notificationModal.IsCompleted = 'Y'
    }

  
    this._adminService.submitDetails(this.notificationModal).subscribe(
      (data: any) => {
     
        ConfigLoaderService.settings.AppSettings.showNotificationMessage=false;
      
        this.alertmsgClass = 'alert alert-success';
        this.alertMsg = this.successMessage;
        this.showalertMsg = true;        
        this.formreset();
   
      $("#success1").toast("show");

        
      },
      (error: any) => {

        this.alertmsgClass = 'alert alert-danger';
        this.alertMsg = this.ErrorMessage;
        this.showalertMsg = false;
        
        $("#error").toast("show");
        this._errorService.handleError(error, this.errModal)

      }
    )

  }

  formreset() {

    this.notificationform.resetForm();
    this.notificationModal.appType = '';
    this.notificationModal.date = '';
    this.notificationModal.userGroup = '';
    this.notificationModal.message = '';

    for (var i = 1; i <= this.userGroupList.length; i++) {
      var x = document.getElementById("UGroup")?.children[i];
    
      x?.removeAttribute("selected");
      x?.removeAttribute("style");

    }
    this.isDisabled=false;

  }

}
